import { useEffect, useRef, useState } from "react";
import { useRecoilValue } from "recoil";
import {
  deleteExpense,
  ExpenseMainType,
  ExpenseSubType,
  getExpense,
  PaymentMethod,
  saveExpense,
  SettlementExpenseDto,
  updateExpense,
} from "../../../../api/settlement";
import { PaginationWrapper } from "../../../../component/CommonTable";
import PopupPagination from "../../../../component/Pagination/popupPagination";
import { pubState } from "../../../../recoil/pub.atom";
import {
  ExpenditureInput,
  ExpenditureItemWrapper,
  ExpenditureTable,
  ExpenditureTableBody,
  ExpenditureTableHeader,
  ExpenditureWrapper,
  PopupHeader,
} from "../../style/popup";
import { Title } from "../../../../styles/page";
import {
  getPayTypeText,
  getExpenseTypeText,
} from "../../utils/settlement.util";
import TableDropBox from "../../../../component/TableDropBox";

export const ExpenseTypeList = [
  {
    value: ExpenseMainType.TAX_PUBLIC,
    subValue: null,
    name: "[1]세금과공과",
  },
  {
    value: ExpenseMainType.TAX_PUBLIC,
    subValue: ExpenseSubType.TAX,
    name: "[1-1]세금",
  },
  {
    value: ExpenseMainType.TAX_PUBLIC,
    subValue: ExpenseSubType.PUBLIC_CHARGE,
    name: "[1-2]공과",
  },
  {
    value: ExpenseMainType.RABBIT_PURCHASE,
    subValue: null,
    name: "[2]로열티외",
  },
  { value: ExpenseMainType.LABOR, subValue: null, name: "[3]인건비" },
  {
    value: ExpenseMainType.LABOR,
    subValue: ExpenseSubType.DEALER,
    name: "[3-1]딜러",
  },
  {
    value: ExpenseMainType.LABOR,
    subValue: ExpenseSubType.COUNTER,
    name: "[3-2]카운터",
  },
  {
    value: ExpenseMainType.LABOR,
    subValue: ExpenseSubType.FLOOR,
    name: "[3-3]플로어",
  },
  {
    value: ExpenseMainType.RENT_MANAGEMENT,
    subValue: null,
    name: "[4]임차료및관리비",
  },
  {
    value: ExpenseMainType.RENT_MANAGEMENT,
    subValue: ExpenseSubType.RENT,
    name: "[4-1]임차료",
  },
  {
    value: ExpenseMainType.RENT_MANAGEMENT,
    subValue: ExpenseSubType.MANAGEMENT_FEE,
    name: "[4-2]관리비",
  },
  { value: ExpenseMainType.SALARY, subValue: null, name: "[5]급여" },
  {
    value: ExpenseMainType.DRINK_PURCHASE,
    subValue: null,
    name: "[6]주류음료매입",
  },
  {
    value: ExpenseMainType.TAX_LABOR_BOOK,
    subValue: null,
    name: "[7]세금노무기장",
  },
  {
    value: ExpenseMainType.MARKETING,
    subValue: null,
    name: "[8]광고마케팅비",
  },
  {
    value: ExpenseMainType.INSURANCE_COMM,
    subValue: null,
    name: "[9]보험료및통신비",
  },
  {
    value: ExpenseMainType.INSURANCE_COMM,
    subValue: ExpenseSubType.INSURANCE,
    name: "[9-1]보험료",
  },
  {
    value: ExpenseMainType.INSURANCE_COMM,
    subValue: ExpenseSubType.COMMUNICATION,
    name: "[9-2]통신비",
  },
  {
    value: ExpenseMainType.SUPPLIES_RENTAL,
    subValue: null,
    name: "[10]비품및렌탈",
  },
  { value: ExpenseMainType.ETC, subValue: null, name: "[11]기타" },
  { value: ExpenseMainType.INTERIOR, subValue: null, name: "[12]인테리어" },
];

const paymentMethods = [
  { value: PaymentMethod.CASH, name: "현금" },
  { value: PaymentMethod.BANK_TRANSFER, name: "계좌이체" },
  { value: PaymentMethod.CARD, name: "카드" },
];
interface Props {
  onClose: () => void;
  setSettlementExpenseList: (v: SettlementExpenseDto[]) => void;
  settlementExpenseList: SettlementExpenseDto[];
  dailyDate: string;
}

const ExpenditurePopup = ({
  onClose,
  settlementExpenseList,
  setSettlementExpenseList,
  dailyDate,
}: Props) => {
  const pub = useRecoilValue(pubState);
  const inputRef1 = useRef<HTMLInputElement | null>(null);
  const inputRef2 = useRef<HTMLInputElement | null>(null);
  const [description, setDescription] = useState<string>("");
  const [amount, setAmount] = useState<number | null>();
  const [editDescription, setEditDescription] = useState<string>("");
  const [editAmount, setEditAmount] = useState<number | null>();
  const [list, setList] = useState<SettlementExpenseDto[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [time, setTime] = useState<string>("");
  const [editItem, setEditItem] = useState<SettlementExpenseDto | null>(null);
  const [mainType, setMainType] = useState<ExpenseMainType | null>(
    ExpenseMainType.TAX_PUBLIC,
  );
  const [subType, setSubType] = useState<ExpenseSubType | null>(null);
  const [paymentMethod, setPaymentMethod] = useState<PaymentMethod>(
    PaymentMethod.CASH,
  );
  const [editMainType, setEditMainType] = useState<ExpenseMainType>(
    ExpenseMainType.TAX_PUBLIC,
  );
  const [editSubType, setEditSubType] = useState<ExpenseSubType | null>(null);
  const [editPaymentMethod, setEditPaymentMethod] = useState<PaymentMethod>(
    PaymentMethod.CASH,
  );

  const handleSave = async () => {
    if (!pub || !amount || !mainType) return;
    const item = {
      description: description,
      amount: amount,
      mainType,
      subType,
      paymentMethod,
    };
    try {
      await saveExpense(item, pub.id, dailyDate);
      await getData();
      setDescription("");
      setAmount(null);
      setMainType(null);
      setSubType(null);
      setPaymentMethod(PaymentMethod.CASH);
    } catch (e) {}
  };

  const handleDelete = async (item: SettlementExpenseDto) => {
    if (!pub || !item.id) return;
    try {
      await deleteExpense(item.id);
      await getData();
    } catch (e) {}
  };

  const handleUpdate = async (item: SettlementExpenseDto) => {
    if (!pub || !editAmount || !item.id) return;
    const request = {
      description: editDescription,
      amount: editAmount,
      mainType: editMainType,
      subType: editSubType,
      paymentMethod: editPaymentMethod,
    };
    try {
      await updateExpense(request, item.id);
      await getData();
    } catch (e) {}
  };

  const getData = async () => {
    if (!pub) return;
    try {
      const res = await getExpense(pub.id, dailyDate);
      setSettlementExpenseList(res);
      setList(res.slice((currentPage - 1) * 9, currentPage * 9));
      setTotalPage(Math.max(1, Math.ceil(res.length / 9)));
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    setList(
      settlementExpenseList.slice((currentPage - 1) * 9, currentPage * 9),
    );
  }, [currentPage]);

  const getTime = () => {
    const date = new Date();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(getTime());
    }, 10000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    setTime(getTime());
  }, []);

  const formatNumber = (num: number) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const formatCreatedAt = (dateString?: string) => {
    if (!dateString) return "";
    const date = new Date(dateString);

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  const handleEdit = (item: SettlementExpenseDto) => {
    if (editItem !== item) {
      setEditItem(item);
      setEditDescription(item.description);
      setEditAmount(item.amount);
      setEditMainType(item.mainType);
      setEditSubType(item.subType ? item.subType : null);
      setEditPaymentMethod(item.paymentMethod);
    } else {
      handleUpdate(item);
      setEditItem(null);
      setEditDescription("");
      setEditAmount(null);
    }
  };

  const header = [
    {
      header: "시간",
      className: "time",
      render: (item: SettlementExpenseDto) => formatCreatedAt(item.createdAt),
    },
    {
      header: "계정과목",
      className: "input",
      render: (item: SettlementExpenseDto) =>
        getExpenseTypeText(item.subType ? item.subType : item.mainType),
    },
    {
      header: "결제수단",
      className: "input",
      render: (item: SettlementExpenseDto) =>
        getPayTypeText(item.paymentMethod),
    },
    {
      header: "내역",
      className: "input",
      render: (item: SettlementExpenseDto) => item.description,
    },
    {
      header: "금액",
      className: "input",
      render: (item: SettlementExpenseDto) => item.amount?.toLocaleString(),
    },
  ];

  return (
    <>
      <ExpenditureWrapper>
        <PopupHeader>
          <Title>지출 내역</Title>
          <div className="box">
            <div className="back" onClick={() => onClose()}>
              <img src="/image-web/solution/close.svg" alt="close" />
            </div>
          </div>
        </PopupHeader>
        <ExpenditureTable>
          <ExpenditureTableHeader>
            {header.map((header, h) => (
              <div key={h} className={`item ${header.className}`}>
                {header.header}
              </div>
            ))}
            <div className="item box"></div>
          </ExpenditureTableHeader>
          <ExpenditureTableBody>
            <ExpenditureItemWrapper border={true}>
              <div className="item time">{time}</div>
              <div className="item input">
                <TableDropBox
                  value={mainType}
                  setValue={setMainType}
                  subValue={subType}
                  setSubValue={setSubType}
                  list={ExpenseTypeList}
                  isSearch={true}
                />
              </div>
              <div className="item input">
                <TableDropBox
                  value={paymentMethod}
                  setValue={setPaymentMethod}
                  list={paymentMethods}
                />
              </div>
              <ExpenditureInput className="input" width={146}>
                <input
                  type="text"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  onKeyUp={(e) => {
                    if (e.key === "Enter") {
                      inputRef2.current?.focus();
                    }
                  }}
                  ref={inputRef1}
                />
              </ExpenditureInput>
              <ExpenditureInput className="input" width={106}>
                <input
                  type="text"
                  value={amount ? formatNumber(amount) : ""}
                  onChange={(e) => {
                    const rawValue = e.target.value.replace(/,/g, "");
                    setAmount(Number(rawValue));
                  }}
                  ref={inputRef2}
                  onKeyUp={(e) => {
                    if (e.key === "Enter") {
                      handleSave();
                    }
                  }}
                />
              </ExpenditureInput>
              <div className="item box">
                <div className="button purple" onClick={() => handleSave()}>
                  저장
                </div>
              </div>
            </ExpenditureItemWrapper>
            {list.map((item, index) =>
              editItem !== item ? (
                <ExpenditureItemWrapper key={index}>
                  {header.map((header, h) => (
                    <div key={h} className={`item ${header.className}`}>
                      {header.render(item)}
                    </div>
                  ))}
                  <div className="item box">
                    <div
                      className="button gray"
                      onClick={() => handleEdit(item)}
                    >
                      수정
                    </div>
                    <div
                      className="button red"
                      onClick={() => {
                        if (!item.id) return;
                        handleDelete(item);
                      }}
                    >
                      삭제
                    </div>
                  </div>
                </ExpenditureItemWrapper>
              ) : (
                <ExpenditureItemWrapper key={index}>
                  <div className="item time">
                    {item.createdAt && formatCreatedAt(item.createdAt)}
                  </div>
                  <div className="item input">
                    <TableDropBox
                      value={editMainType}
                      setValue={setEditMainType}
                      subValue={editSubType}
                      setSubValue={setEditSubType}
                      list={ExpenseTypeList}
                    />
                  </div>
                  <div className="item input">
                    <TableDropBox
                      value={editPaymentMethod}
                      setValue={setEditPaymentMethod}
                      list={paymentMethods}
                    />
                  </div>
                  <ExpenditureInput className="input" width={146}>
                    <input
                      type="text"
                      value={editDescription}
                      onChange={(e) => setEditDescription(e.target.value)}
                    />
                  </ExpenditureInput>
                  <ExpenditureInput className="input" width={106}>
                    <input
                      type="text"
                      value={editAmount ? formatNumber(editAmount) : ""}
                      onChange={(e) => {
                        const rawValue = e.target.value.replace(/,/g, "");
                        setEditAmount(Number(rawValue));
                      }}
                    />
                  </ExpenditureInput>
                  <div className="item box">
                    <div className="button" onClick={() => handleEdit(item)}>
                      수정
                    </div>
                    <div
                      className="button red"
                      onClick={() => {
                        if (!item.id) return;
                        handleDelete(item);
                      }}
                    >
                      삭제
                    </div>
                  </div>
                </ExpenditureItemWrapper>
              ),
            )}
          </ExpenditureTableBody>
        </ExpenditureTable>
        {totalPage > 1 && (
          <PaginationWrapper>
            <PopupPagination
              currentPage={currentPage}
              totalPages={totalPage}
              onPageChange={setCurrentPage}
            />
          </PaginationWrapper>
        )}
        <div className="button" onClick={() => onClose()}>
          완료
        </div>
      </ExpenditureWrapper>
    </>
  );
};

export default ExpenditurePopup;
